import { get, post } from "../../../services/request";

export const getAllCommunications = (data) =>
    post('NotificationDataCenter/GetAllCommunications', data);
export const enableDisableCommunications = (data) =>
    post('NotificationDataCenter/EnableDisableCommunications', data);
export const getCommunicationsDocumentTypeForDropdown = () =>
    get('Common/GetCommunicationsDocumentTypeForDropdown');
